import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Property from "@/model/property";
import FloorPlan from "@/model/floor";

@Module({ namespaced: true })
export default class PropertyModule extends VuexModule {
  public property: Property = null;
  public propertySelected: [];
  @Mutation
  set(property: Property): void {
    this.property = property;
  }

  @Mutation
  upSelectedPropery(properties: []): void {
    this.propertySelected = properties;
  }

  @Mutation
  setFloorPlanId(floorPlanId: string): void {
    this.property.floor_plan_id = floorPlanId;
  }

  @Mutation
  setDateOfConstruction(dateOfConstruction: string): void {
    this.property.date_of_construction = dateOfConstruction;
  }

  @Mutation
  setFloorPlanUrl(floorPlan: FloorPlan): void {
    this.property.floor_plan = floorPlan;
  }

  @Action({ rawError: true })
  setProperty(property: Property) {
    this.context.commit("set", property);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", null);
  }

  @Action({ rawError: true })
  setSelectedPropery(properties: []) {
    this.context.commit("upSelectedPropery", properties);
  }

  @Action({ rawError: true })
  setFloorPlanIdProperty(floorPlanId: string) {
    this.context.commit("setFloorPlanId", floorPlanId);
  }

  @Action({ rawError: true })
  setFloorPlanUrlProperty(floorPlan: FloorPlan) {
    this.context.commit("setFloorPlanUrl", floorPlan);
  }

  @Action({ rawError: true })
  setDateOfConstructionProperty(dateOfConstruction: string) {
    this.context.commit("setDateOfConstruction", dateOfConstruction);
  }

  get getProperty(): Property {
    return this.property;
  }
}
